import { lazy } from 'react';
import { CRoutes } from 'src/routes';

/** import pages */
const TestSubscriptions = lazy(() => import('src/components/Test/TestSubscriptions'));
const TestManyInputs = lazy(() => import('src/components/Test/manyInputs'));
const TestModals = lazy(() => import('src/components/Test/modal'));
const TestCancellableAxios = lazy(() => import('src/components/Test/CancellableAxios'));
const TestPaymentMethod = lazy(() => import('src/components/Test/paymentMethod'));
const TestNewForm = lazy(() => import('src/components/Test'));
const TestMaterialInputs = lazy(() => import('src/components/Test/MaterialInputs'));

/** export routes */
export const testRoutes: CRoutes = [
  {
    path: '/test/testMaterialInputs/:stateForm?',
    Component: TestMaterialInputs,
  },
  {
    path: '/test/testNewForm',
    Component: TestNewForm,
    allowAnonymous: true,
  },
  process.env.NODE_ENV === 'development' && {
    path: '/test/testCancellableAxios',
    Component: TestCancellableAxios,
    layout: 'minimal',
  },
  process.env.NODE_ENV === 'development' && {
    path: '/test/testmodals',
    Component: TestModals,
  },
  process.env.NODE_ENV === 'development' && {
    path: '/test-many-inputs',
    Component: TestManyInputs,
  },
  process.env.NODE_ENV === 'development' && {
    path: '/test-subscriptions',
    Component: TestSubscriptions,
    layout: 'minimal',
  },
  process.env.NODE_ENV === 'development' && {
    path: '/test-payment-method',
    Component: TestPaymentMethod,
    layout: 'minimal',
  },
].filter(Boolean) as CRoutes; // filter conditional routes
